import * as _ from 'underscore';
import { Keys } from '../helpers/Keys';
import { Module } from '../Module';

// This directive was inspired by http://vitalets.github.io/angular-xeditable/#text-simple
// It displays text and an edit button on hover.  When clicking on the text or the button,
// a text input and confirmation buttons appear for editing

interface IEditableTextAttributes extends ng.IAttributes {
  ngModel: string;
  onBeforeSave: string;
  editButtonText: string;
}

export interface IEditableTextScope extends ng.IScope {
  onBeforeSave: (locals: { newText: string }) => ng.IPromise<any>;
  editButtonText: string;

  // private

  // states
  editMode: boolean;
  readonly: boolean;
  editable: boolean;
  invalid: boolean;
  busy: boolean;

  // variables
  modelValue: string;
  viewValue: string;

  // methods
  edit(): void;
  save(): void;
  cancel(): void;
}

Module.instance().directive('tbEditableText', <any[]>[
  '$timeout',
  ($timeout: ng.ITimeoutService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'editableText.html',
      scope: {
        onBeforeSave: '&',
        editButtonText: '@',
        maxlength: '@'
      },
      require: 'ngModel',
      link: ($scope: IEditableTextScope, element: JQuery, attrs: IEditableTextAttributes, ngModelCtrl: ng.INgModelController) => {
        const input = element.find('.tb-edit-text-input');

        ngModelCtrl.$render = () => {
          $scope.modelValue = ngModelCtrl.$modelValue;
          $scope.viewValue = ngModelCtrl.$modelValue;
        };

        attrs.$observe('readonly', (attrReadonly: any) => {
          $scope.readonly = !!attrReadonly;
          element.toggleClass('tb-readonly', $scope.readonly);
        });

        // When ever the viewValue changes, run the parsers against the newViewValue to validate the newViewValue
        $scope.$watch(() => $scope.viewValue, (newViewValue: string) => {
          _.forEach(ngModelCtrl.$parsers, (fn: (val: any) => any) => fn(newViewValue));
          $scope.invalid = ngModelCtrl.$invalid;
        });

        $scope.editable = false;

        const reset = () => {
          $scope.editMode = false;
          $scope.busy = false;
        };
        reset();

        $scope.edit = () => {
          if($scope.readonly) return;

          $scope.editMode = true;
          $scope.busy = false;
        };

        $scope.save = () => {
          const newText = $scope.viewValue;
          $scope.busy = true;

          $scope.onBeforeSave({ newText: newText}).then(
            // Success
            () => {
              ngModelCtrl.$setViewValue(newText);
              ngModelCtrl.$render();
              reset();
            },
            // Error
            () => {
              $scope.busy = false;
              // Reapply focus so the user can edit
              $timeout(() => input.focus());
            }
          );
        };

        $scope.cancel = () => {
          ngModelCtrl.$render(); // Restores the original value
          $scope.editMode = false;
        };

        input.on('keydown', ($event: JQuery.Event) => {
          switch ($event.which) {

            // Save on Enter
            case Keys.Enter:
              $scope.$apply(() => $scope.save());
              break;

            // Cancel on escape
            case Keys.Escape:
              $scope.$apply(() => $scope.cancel());
              break;
          }
        });
      }
    };
  }
]);
